import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../../actions/appDataActions';
import OptionFeeback from '../OptionFeedback';//eslint-disable-line import/no-named-as-default
import ScoreKpi from '../../kpi/ScoreKpi';//eslint-disable-line import/no-named-as-default
import Image from '../../../objects/image/SecondaryImage';
import Resources from '../../resourceLinks/ResourceLinks';
import AudioControls from "../../audio/SimpleAudioController";
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as userDataActions from '../../../../actions/userDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as kpiConstants from '../../../../constants/kpiConstants';
import * as assetConstants from '../../../../constants/assetConstants';
import * as appConstants from "../../../../constants/appConstants";
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import * as imageHelper from '../../../../helpers/imageHelper';
import _ from 'lodash';
import * as animationHelper from "../../../../helpers/animationHelper";

class MultipleAnswerFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            options: this.props.options,
            locale: appHelper.getLocalData(this.props.responseData.outcome),
            hideFeedback: this.props.hideFeedback,
            showFeedbackContent: false,
            showKpis: appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis !== null && this.props.responseData.outcome.kpis.length > 0,
            showProgression: false,
            enableProgression: appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis !== null && this.props.responseData.outcome.kpis.length === 0,
            optionFeedback: [],
            kpiDashboardParams: {
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: false,
            dialogComplete: true,
            hasBadges: appHelper.isDefined(this.props.responseData.outcome.badges) && this.props.responseData.outcome.badges.length > 0,
            badgesCollected: false,
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            optionResourceLinks: [],
            hasOptionsResources: false,
            optionResourcesAreComplete: true,
            missedOptions: {
                show: false,
                options: []
            },
            completionCalled: false,
            feedbackInterval: {},
            review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
            updateLocale: false,
            hasLeftAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.left),
            hasRightAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.right),
            hasTopAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.top),
            hasBottomAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.bottom),
            imageStyles: {},
            imageClass: "",
            updateImageStyles: false,
            imageStylesSet: false,
            feedbackAsset: {
                src: ""
            },
            feedbackAssetData: {},
            refValue: `${this.props.asset_id}_feedbackWrapper`,
            creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            audio: {
                src: "",
            },
            showLabels: true,
            showAnimation: false,
        };
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.handleOptionFeedback = this.handleOptionFeedback.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.getLinkClass = this.getLinkClass.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.onKeyMessageToolboxComplete = this.onKeyMessageToolboxComplete.bind(this);
        this.setKeyMessageToolboxCallbacks = this.setKeyMessageToolboxCallbacks.bind(this);
        this.checkAllKeyMessageToolboxesComplete = this.checkAllKeyMessageToolboxesComplete.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getMissedOptions = this.getMissedOptions.bind(this);
        this.checkIsReadyToComplete = this.checkIsReadyToComplete.bind(this);
        this.setComplete = this.setComplete.bind(this);
        this.showProgressButton = this.showProgressButton.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onReview = this.onReview.bind(this);
        this.setFeedbackInterval = this.setFeedbackInterval.bind(this);
        this.checkShowProgressButton = this.checkShowProgressButton.bind(this);
        //new
        this.getImagePath = this.getImagePath.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.showTopOrLeftAssetColumn = this.showTopOrLeftAssetColumn.bind(this);
        this.showBottomOrRightAssetColumn = this.showBottomOrRightAssetColumn.bind(this);
        this.setOptionResources = this.setOptionResources.bind(this);
        this.onOptionResourcesComplete = this.onOptionResourcesComplete.bind(this);

        //Create Refs
        this.feedbackPanel = React.createRef();
        this.contentWrapper = React.createRef();
    }

    componentDidMount() {
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.props.responseData.outcome.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.props.responseData.outcome.character_pose);
        }
        //this.setResources();
        this.getAssets();
        this.getMissedOptions();
        this.handleOptionFeedback();
        this.getImageStyles();
        this.setFeedbackInterval();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.hideFeedback !== nextProps.hideFeedback) {
            this.setState({hideFeedback: nextProps.hideFeedback});
        }
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.responseData.outcome),
                review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
                updateLocale: true,
                creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            });
        }
    }


    componentDidUpdate() {
        if (this.checkIsReadyToComplete()) {
            this.setComplete();
        }

        if (this.state.hideFeedback) {
            this.hide();
        }

        if (this.state.updateLocale) {
            this.handleOptionFeedback();
        }

        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.feedbackInterval);
    }

    setFeedbackInterval() {
        let interval = setInterval(this.checkShowProgressButton, 500);
        this.setState({feedbackInterval: interval});
    }

    checkShowProgressButton() {
        if (this.showProgressButton()) {
            clearInterval(this.state.feedbackInterval);
            this.props.onEnableProgression(this.state.locale.progression_label);

        }
    }

    storeUserResponse() {
        //console.log(`storeUserResponse`);
        let selectedOptions = [];
        for (let i = 0; i < this.props.responseData.checkedOptions.length; i++) {
            let selectedOption = this.props.responseData.checkedOptions[i];
            selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
        }

        let responseObj = {
            asset_id: this.props.asset_id,
            selectedOptions: selectedOptions,
            kpis: !appHelper.isDefined(this.props.responseData.outcome.kpis) || this.props.responseData.outcome.kpis !== null ? this.props.responseData.outcome.kpis : [],
            indicators: appHelper.isDefined(this.props.responseData.outcome.indicators) && this.props.responseData.outcome.indicators !== null ? this.props.responseData.outcome.indicators : [],

        };


        //console.log(responseObj);
        //console.log(this.props.callbacks);
        this.props.callbacks.storeUserResponse(responseObj);
    }

    getLocale() {
        this.setState({locale: Object.assign({}, appHelper.getLocalData(this.props.responseData.outcome))});

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {

        let feedbackAsset = {};
        let feedbackAssetData = {};

        if (this.state.hasLeftAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.left);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.left);
        } else if (this.state.hasRightAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.right);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.right);
        } else if (this.state.hasTopAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.top);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.top);
        } else if (this.state.hasBottomAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.bottom);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.bottom);
        }


        if (feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            feedbackAssetData = Object.assign({}, feedbackAssetData, {
                allow_diagram_zoom: this.props.responseData.outcome.feedback_settings.allow_diagram_zoom,
                show_diagram_title: this.props.responseData.outcome.feedback_settings.show_diagram_title,
                show_diagram_description: this.props.responseData.outcome.feedback_settings.show_diagram_description,

            });
        }

        this.setState({
            feedbackAsset: Object.assign({}, feedbackAsset),
            feedbackAssetData: Object.assign({}, feedbackAssetData),
            enableProgression: !appHelper.isDefined(this.state.feedbackAssetData.constant) || this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT ? true : this.state.enableProgression
        });

        if (appHelper.isDefined(this.props.responseData.outcome.assets)) {
            let imageAsset = appHelper.getImageAsset(this.props.responseData.outcome.assets);
            //imageAsset = appHelper.isDefined(imageAsset.locale) ? appHelper.getLocalData(imageAsset) : imageAsset;

            if (appHelper.isDefined(imageAsset) && imageAsset.src.length > 0) {
                this.setState({imageAsset: imageAsset});
            }
        }

        if (appHelper.isDefined(this.props.responseData.outcome.audio) && appHelper.isDefined(this.state.locale.audio)) {
            let audio = appHelper.getAudioAsset(this.state.locale.audio);
            if (appHelper.isDefined(this.props.responseData.outcome.audio.enabled) && this.props.responseData.outcome.audio.enabled) {
                if (appHelper.isDefined(this.props.responseData.outcome.audio.show_audio_controls) && this.props.responseData.outcome.audio.show_audio_controls) {
                    this.setState({
                        audio: Object.assign({}, audio),
                    });
                } else {
                    let audioObj = {
                        audioRef: `audio_${audio.id}_${audio.type}`,
                    };
                    if (appHelper.isDefined(this.props.responseData.outcome.audio.auto_play) && this.props.responseData.outcome.audio.auto_play) {
                        this.props.actions.setAudio(audioObj);
                    }
                }
            }
        }
    }

    getAssetType(asset) {
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
            returnAsset = Object.assign({}, asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    onFeedbackRevealed() {
        this.storeUserResponse();
        this.scrollToTop();
    }

    scrollToTop() {
        let feedback = document.getElementById(`feedback_wrapper_${this.props.asset_id}`);
        this.props.callbacks.scrollToFeedback(feedback.offsetTop);

    }

    enableProgression() {
        this.setState({enableProgression: true});
    }

    getLinkClass() {
        return this.state.enableProgression ? "" : "disabled-link";
    }

    getDisabledState() {
        return !this.state.enableProgression;
    }

    handleOptionFeedback() {
        this.setState({updateLocale: false});
        let optionFeeback = [];
        let resources = [];

        //set parent array with feedback
        for (let i = 0; i < this.state.options.length; i++) {
            let option = this.state.options[i];
            let locale = appHelper.getLocalData(option);
            let feedback = "";

            if (appHelper.isDefined(locale.feedback) && locale.feedback.length > 0 && locale.feedback !== "<p><br></p>") {
                feedback = locale.feedback;
            } else if (appHelper.isDefined(option.feedback_id)) {
                let feedbackOption = appHelper.getArrayObjectByKey(this.state.options, "option_id", option.feedback_id);
                let feedbackOptionLocale = appHelper.getLocalData(feedbackOption);
                feedback = feedbackOptionLocale.feedback;
            }
            let feedbackObj = {
                option_id: option.option_id,
                feedback: feedback,
                resourceLinks: appHelper.setResourceLinks(option),
                options: [],
                checked: false
            };

            optionFeeback = dataHelper.immutablePush(optionFeeback, feedbackObj);
        }

        for (let o = 0; o < this.state.options.length; o++) {
            let option = this.state.options[o];
            let locale = appHelper.getLocalData(option);
            let optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.checkedOptions, "option_id", option.option_id);
            let optionObject = {
                result: option.result,
                className: optionCheckedIndex > -1 ? 'checked' : 'unchecked',
                option_text: locale.option,
                option_id: option.option_id,
                kpis: appHelper.isDefined(option.kpis) && option.kpis !== null ? option.kpis : []
            };

            //if (optionCheckedIndex > -1 || this.props.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
            if (optionCheckedIndex > -1) {
                if (!appHelper.isDefined(option.feedback_id)) {
                    let optionFeedbackObj = appHelper.getArrayObjectByKey(optionFeeback, "option_id", option.option_id);
                    let optionFeedbackObjIndex = appHelper.getArrayObjectIndexByKey(optionFeeback, "option_id", option.option_id);

                    optionFeedbackObj = Object.assign({}, optionFeedbackObj,
                        {
                            options: dataHelper.immutablePush(optionFeedbackObj.options, optionObject),
                            checked: !optionFeedbackObj.checked && optionCheckedIndex > -1
                        }
                    );
                    optionFeeback = dataHelper.immutableSplice(optionFeeback, optionFeedbackObjIndex, 1, optionFeedbackObj);
                } else {
                    let optionFeedbackObj = appHelper.getArrayObjectByKey(optionFeeback, "option_id", option.feedback_id);
                    let optionFeedbackObjIndex = appHelper.getArrayObjectIndexByKey(optionFeeback, "option_id", option.feedback_id);

                    optionFeedbackObj = Object.assign({}, optionFeedbackObj,
                        {
                            options: dataHelper.immutablePush(optionFeedbackObj.options, optionObject),
                            checked: !optionFeedbackObj.checked && optionCheckedIndex > -1
                        }
                    );
                    optionFeeback = dataHelper.immutableSplice(optionFeeback, optionFeedbackObjIndex, 1, optionFeedbackObj);
                }

                let resourceLinks = appHelper.setResourceLinks(option);
                _.forEach(resourceLinks, function (resource) {
                    resources = dataHelper.immutablePush(resources, resource);
                });
            }
        }

        if (optionFeeback.length > 1) {

            optionFeeback.sort(function (a, b) {
                if (a.checked > b.checked) return -1;
                if (a.checked < b.checked) return 1;
                return 0;
            });
        }

        this.setState({optionFeedback: Object.assign([], optionFeeback)});
        this.setResources(resources);
        this.setOptionResources(resources);
    }

    getMissedOptions() {
        let missedOptions = [];
        for (let o = 0; o < this.state.options.length; o++) {
            let option = this.state.options[o];
            let locale = appHelper.getLocalData(option);
            let optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.checkedOptions, "option_id", option.option_id);
            let optionObject = {
                result: option.result,
                className: optionCheckedIndex > -1 ? 'checked' : 'unchecked',
                option_text: locale.option,
                option_id: option.option_id
            };
            if (optionCheckedIndex === -1 && this.props.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
                missedOptions = dataHelper.immutablePush(missedOptions, optionObject);
            }
        }
        if (missedOptions.length > 0) {
            this.setState({
                missedOptions: Object.assign({}, this.state.missedOptions, {
                    show: true,
                    options: Object.assign([], missedOptions)
                })
            });
        }
    }

    onFeedbackHidden() {
        this.setState(
            {
                //showResponse: false,
                showFeedbackContent: false,
                showKpis: false,
                showProgression: false
            }
        );
        //this.props.callbacks.resizeWatcher();
        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }


    onProgressionClicked() {
        this.hide();
    }

    show() {
        let feedbackPanel = this.feedbackPanel.current;
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackRevealed
        };
        animationHelper.showHeight(params);
    }

    hide() {
        this.setState({hideFeedback: false});
        let feedbackPanel = this.feedbackPanel.current;// this.refs[`${this.props.asset_id}_feedbackPanel`];
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackHidden
        };
        animationHelper.hideHeight(params);
    }

    onToolboxComplete() {
        this.setState({toolboxIsComplete: true});
    }

    setToolboxCallbacks() {
        this.setState(
            {
                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks,
                    {
                        onObjectComplete: this.onToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onKeyMessageToolboxComplete() {
        this.setState({
            completeKeyMessageToolboxes: this.state.completeKeyMessageToolboxes + 1,
            checkKeyMessageToolboxesCount: true
        });
        //console.log(`onKeyMessageToolboxComplete ${this.state.keyMessagesToolbox.length}`);
        //this.setState({keyMessageToolboxIsComplete: true});
    }

    checkAllKeyMessageToolboxesComplete() {

        this.setState({
            checkKeyMessageToolboxesCount: false,
            keyMessageToolboxIsComplete: this.state.completeKeyMessageToolboxes >= this.state.keyMessagesToolbox.length
        });
    }

    setKeyMessageToolboxCallbacks() {
        this.setState(
            {
                keyMessageToolboxCallbacks: Object.assign({}, this.state.keyMessageToolboxCallbacks,
                    {
                        onObjectComplete: this.onKeyMessageToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }

    dialogsOnComplete() {
        this.setState({dialogComplete: true});
    }

    setResources(resources) {
        let outcomeLinks = appHelper.setResourceLinks(this.props.responseData.outcome);
        //let resourceLinks =  [...resources, ...outcomeLinks];
        let hasRequiredResources = appHelper.hasRequiredResources(outcomeLinks);
        this.setState({
            resourceLinks: Object.assign([], outcomeLinks),
            hasResources: outcomeLinks.length > 0,
            resourcesAreComplete: outcomeLinks.length === 0 || !hasRequiredResources
        });
    }

    setOptionResources(resources) {

        //let resourceLinks =  [...resources, ...outcomeLinks];
        let hasRequiredResources = appHelper.hasRequiredResources(resources);
        this.setState({
            optionResourceLinks: Object.assign([], resources),
            hasOptionsResources: resources.length > 0,
            optionResourcesAreComplete: resources.length === 0 || !hasRequiredResources
        });
    }

    _setResources(resources) {
        let outcomeLinks = appHelper.setResourceLinks(this.props.responseData.outcome);
        let resourceLinks = [...resources, ...outcomeLinks];
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });
    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    onOptionResourcesComplete() {
        if (!this.state.optionResourcesAreComplete) {
            this.setState({optionResourcesAreComplete: true, checkComplete: true});
        }
    }

    checkIsReadyToComplete() {
        return !this.props.callbacks.hasNextObject(this.props.index)
            && this.props.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
            && this.state.enableProgression
            && !this.state.completionCalled
            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete
            && this.state.optionResourcesAreComplete;
    }

    setComplete() {
        this.setState({completionCalled: true});
        this.props.onComplete();
    }

    showProgressButton() {
        /*return (
            (!this.props.callbacks.hasNextObject(this.props.screenObject) && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || this.props.callbacks.hasNextObject(this.props.screenObject))
            && appHelper.isDefined(this.state.locale.progression_label)
            && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;*/

        return this.state.enableProgression
            && appHelper.isDefined(this.state.locale.progression_label)
            // && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete
            && this.state.optionResourcesAreComplete;
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.enableProgression) {
                this.onReview();
            }
        }
    }

    onReview() {
        this.props.onShowReview(`review_link_${this.props.asset_id}`);

    }

    setClass() {

        let className = "";
        if (appHelper.isDefined(this.props.responseData.outcome.feedback_settings.class_name) && this.props.responseData.outcome.feedback_settings.class_name.length > 0) {
            className += ` ${this.props.responseData.outcome.feedback_settings.class_name}`;
        } else {
            className += "standard-block";
        }

        if (appHelper.isDefined(this.props.responseData.outcome.feedback_settings.bullet_list_style) && this.props.responseData.outcome.feedback_settings.bullet_list_style !== null) {
            className += ` ${this.props.responseData.outcome.feedback_settings.bullet_list_style}`;
        }
        return className;
    }

    setIconClass() {
        let iconClass = '';

        if (this.state.hasLeftAsset) {

            iconClass += 'left-asset ';
        } else if (this.state.hasRightAsset) {
            iconClass += 'right-asset ';
        } else if (this.state.hasTopAsset) {
            iconClass += 'top-asset ';
        } else if (this.state.hasBottomAsset) {
            iconClass += 'bottom-asset ';
        }

        if (this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            iconClass += 'image ';
        }
        return iconClass;
    }

    getImageStyles() {
        let refValue = this.contentWrapper.current;
        if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.feedbackAsset.src) && this.state.feedbackAsset.src.length > 0) {
            let assetStyles = imageHelper.checkAssetImageWidth(this.props.responseData.outcome.feedback_settings, this.state.feedbackAsset, refValue.offsetWidth).styles;
            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.props.responseData.outcome.feedback_settings),
            });
        }
    }

    showTopOrLeftAssetColumn() {
        let showColumn = false;
        if (this.state.hasLeftAsset) {
            showColumn = true;
            if (this.props.responseData.outcome.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.props.responseData.outcome.feedback_settings.left.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        } else if (this.state.hasTopAsset) {
            showColumn = true;
            if (this.props.responseData.outcome.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.props.responseData.outcome.feedback_settings.top.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        }

        return showColumn;
    }


    showBottomOrRightAssetColumn() {
        let showColumn = false;
        if (this.state.hasRightAsset) {
            showColumn = true;
            if (this.props.responseData.outcome.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.props.responseData.outcome.feedback_settings.right.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        } else if (this.state.hasBottomAsset) {
            showColumn = true;
            if (this.props.responseData.outcome.result === objectConstants.SCORING_TYPE_REFLECTIVE && this.props.responseData.outcome.feedback_settings.bottom.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
                showColumn = false;
            }
        }

        return showColumn;
    }


    render() {
        return (
            <div className="a-c" ref={this.feedbackPanel}>
                <div className={`feedback-panel ${this.props.responseData.outcome.result}`}
                     ref={`${this.props.asset_id}_feedbackPanel`}>
                    <div className="feedback-content-col">

                        <div className={`paragraph-content-wrapper ${this.setIconClass()}`} ref={this.contentWrapper}>
                            {this.showTopOrLeftAssetColumn()
                                ?
                                <div className="asset-column">
                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <Image screenObject={this.state.feedbackAssetData}
                                           imageClass={this.state.imageClass}
                                           imageStyles={this.state.imageStyles}/>

                                    }
                                    {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                         style={this.state.imageStyles}>
                                        <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>
                                    </div>
                                    }

                                    {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                    <div className={`image-credit`}
                                         style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                    }

                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_METRIC_RESULT && this.state.showKpis
                                        ? <ScoreKpi bite_id={this.props.responseData.bite_id}
                                                    displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                                    showTitle={this.state.kpiDashboardParams.showTitle}
                                                    onUpdateComplete={this.enableProgression}/>
                                        : null
                                    }


                                </div>
                                :
                                null
                            }
                            <div className="content-column">

                                {appHelper.isDefined(this.state.locale.feedback) && this.state.dialogComplete && this.state.locale.feedback !== "<p><br></p>" && this.props.responseData.outcome.enable_feedback
                                    ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                                    : null
                                }
                                {
                                    appHelper.isDefined(this.props.responseData.outcome.audio) && appHelper.isDefined(this.props.responseData.outcome.audio.show_audio_controls) && this.props.responseData.outcome.audio.show_audio_controls && appHelper.isDefined(this.state.audio.id)
                                        ?
                                        <AudioControls audio={this.state.audio}
                                                       autoPlay={this.props.responseData.outcome.audio.auto_play}
                                                       showLabels={this.state.showLabels}
                                                       showAnimation={this.state.showAnimation}
                                                       audioRef={`text_audio_${this.props.responseData.outcome.asset_id}_${this.state.audio.id}_${this.state.audio.constant}`}/>
                                        :
                                        null
                                }
                                {
                                    this.state.hasResources
                                        ?
                                        <Resources resources={this.state.resourceLinks}
                                                   onResourcesComplete={this.onResourcesComplete}/>
                                        :
                                        null
                                }

                                {this.state.optionFeedback.length > 0 && this.state.dialogComplete && this.props.responseData.outcome.enable_feedback && this.props.responseData.outcome.feedback_settings.show_individual_feedback
                                    ? <OptionFeeback feedback_options={this.state.optionFeedback}
                                                     asset_id={this.props.asset_id}
                                                     responseData={this.props.responseData}
                                                     missedOptions={this.state.missedOptions}
                                                     optionResourceLinks={this.state.optionResourceLinks}
                                                     hasOptionsResources={this.state.hasOptionsResources}
                                                     optionResourcesAreComplete={this.state.optionResourcesAreComplete}
                                                     onOptionResourcesComplete={this.onOptionResourcesComplete}
                                    />
                                    : null
                                }


                            </div>
                            {this.showBottomOrRightAssetColumn()
                                ?
                                <div className="asset-column">
                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <Image screenObject={this.state.feedbackAssetData}
                                           imageClass={this.state.imageClass}
                                           imageStyles={this.state.imageStyles}/>
                                    }
                                    {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                    &&
                                    <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                         style={this.state.imageStyles}>
                                        <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>


                                    </div>
                                    }
                                    {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                    <div className={`image-credit`}
                                         style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                    }

                                    {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_METRIC_RESULT && this.state.showKpis
                                        ? <ScoreKpi bite_id={this.props.responseData.bite_id}
                                                    displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                                    showTitle={this.state.kpiDashboardParams.showTitle}
                                                    onUpdateComplete={this.enableProgression}/>
                                        : null
                                    }

                                </div>
                                :
                                null
                            }
                        </div>

                        {this.props.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.state.dialogComplete && this.state.resourcesAreComplete && this.state.optionResourcesAreComplete && this.props.responseData.outcome.feedback_settings.include_explore_feedback
                            ?
                            <div className={`guroo-active-link text-center ${this.getLinkClass()}`} role="link"
                                 tabIndex="0"
                                 id={`review_link_${this.props.asset_id}`}
                                 onKeyDown={this.setKeyboardAccessibility}
                                 onClick={this.onReview}>{this.state.review_other_options_label}</div>
                            : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

/*
*  {this.state.keyMessages.length > 0
                        ? <KeyMessages key_messages={this.state.keyMessages}
                                       asset_id={this.props.asset_id}
                                       toolboxCallbacks={this.state.keyMessageToolboxCallbacks}
                                       onComplete={this.showProgressionButton}/>
                        : null
                    }*/
MultipleAnswerFeedback.propTypes = {
    screenObject: PropTypes.object,
    options: PropTypes.array.isRequired,
    key_messages: PropTypes.array,
    responseData: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    index: PropTypes.number,
    onShowReview: PropTypes.func,
    onComplete: PropTypes.func,
    onEnableProgression: PropTypes.func,
    hideFeedback: PropTypes.bool,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

MultipleAnswerFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswerFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswerFeedback.js
 **/